// extracted by mini-css-extract-plugin
module.exports = {"catalog-menu-container":"CatalogMenu_catalog-menu-container__Zfi_U","items":"CatalogMenu_items__PQFam"};